import { Component, ReactNode } from 'react'

import PageLoadRecovery from './PageLoadRecovery.component'
import { isChunkLoadError } from './isChunkLoadError'

type Props = {
  children: ReactNode
  /** Clears the recovery screen when it changes, e.g. on route navigation. */
  resetKey?: string
}

type State = {
  error: unknown
  hasError: boolean
  resetKey?: string
}

/**
 * Shows the page-load recovery screen for lazy chunk failures. Any other
 * error is rethrown so the next boundary keeps its existing handling.
 */
class ChunkLoadErrorBoundary extends Component<Props, State> {
  state: State = {
    error: undefined,
    hasError: false,
    resetKey: this.props.resetKey,
  }

  static getDerivedStateFromError(error: unknown): Partial<State> {
    return { error, hasError: true }
  }

  static getDerivedStateFromProps(
    props: Props,
    state: State,
  ): Partial<State> | null {
    if (props.resetKey === state.resetKey) return null

    return { error: undefined, hasError: false, resetKey: props.resetKey }
  }

  render() {
    const { error, hasError } = this.state

    if (!hasError) return this.props.children
    if (!isChunkLoadError(error)) throw error

    return <PageLoadRecovery />
  }
}

export default ChunkLoadErrorBoundary
